
import { Box, Typography } from "@mui/material";

interface SelectChipProps {
    label: string;
    isSelected: boolean;
    onSelect: () => void;
    maxWidth?: string;
    disabled?: boolean;
}

export const SelectChip = ({ label, isSelected, onSelect, maxWidth = "150px", disabled = false }: SelectChipProps) => {
    return (
        <Box
            maxWidth={maxWidth}
            p={1}
            borderRadius={2}
            border={1}
            borderColor={isSelected ? "primary.main" : "divider"}
            bgcolor={"background.paper"}
            color={isSelected ? "primary.main" : "text.secondary"}
            sx={{
                cursor: disabled ? 'default' : 'pointer',
                '&:hover': {
                    bgcolor: disabled ? "background.paper" : 'grey.50',
                },
                opacity: disabled ? 0.5 : 1,
            }}
            onClick={disabled ? undefined : onSelect}
        >
            <Typography variant="body2" noWrap>
                {label}
            </Typography>
        </Box>
    );
};